<ng-container *transloco="let t;">
  <p-table [value]="data" [paginator]="true" [rows]="50" dataKey="date">

    <ng-template pTemplate="header">
      <tr>
          <th></th>
          <th>{{ t('common.labels.day') }}</th>
          <th>{{ t('common.labels.moderators') }} (&sum;: {{ sums.moderator }})</th>
          <th>{{ t('common.labels.moderators_external') }} (&sum;: {{ sums.moderator_external }})</th>
          <th>{{ t('common.labels.observers') }} (&sum;: {{ sums.observer }})</th>
          <th>{{ t('common.labels.observers_gem') }} (&sum;: {{ sums.observer_gem }})</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-day let-expanded="expanded">
      <tr tabindex="0" [ngClass]="{'expanded': expanded}">
        <td>
          <button type="button" pButton pRipple [pRowToggler]="day" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td>{{ day.date | amDateFormat: 'DD.MM.YYYY' }}</td>
        <td [ngClass]="{restrained: day.moderator === 0}">{{ day.moderator }}</td>
        <td [ngClass]="{restrained: day.moderator_external === 0}">{{ day.moderator_external }}</td>
        <td [ngClass]="{restrained: day.observer === 0}">{{ day.observer }}</td>
        <td [ngClass]="{restrained: day.observer_gem === 0}">{{ day.observer_gem }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-day>
      <tr>
        <td></td>
        <td colspan="5">
          <p-table [value]="day.users" rowGroupMode="rowspan" groupRowsBy="role" sortField="lastname" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                  <th>{{ t('common.labels.role') }}</th>
                  <th>{{ t('common.labels.name') }}</th>
                  <th>{{ t('common.labels.locations') }}</th>
                  <th>{{ t('common.labels.procedures') }}</th>
                  <th>{{ t('common.labels.languages') }}</th>
                  <!-- <th>{{ t('common.labels.day') }}</th> -->
                  <!-- <th>{{ t('common.labels.blocked') }}</th> -->
                  <th>{{ t('common.labels.available') }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-rowIndex="rowIndex" let-rowgroup="rowgroup" let-rowspan="rowspan">
                <tr tabindex="0">
                  <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                    {{ t('common.labels.' + user.role) }}
                  </td>
                  <td>{{ user.name }}</td>
                  <td>{{ user.locations }}</td>
                  <td>{{ user.templates }}</td>
                  <td>{{ user.languages }}</td>
                  <!-- <td>
                    <span *ngIf="user.type">{{ t('common.labels.' + user.type) }}</span>
                    <span *ngIf="!user.type">{{ t('common.labels.allday') }}</span>
                  </td> -->
                  <!-- <td>
                    <ng-container *ngFor="let blocked of user.blocked">
                      <span>{{ blocked.starts_at | amLocal | amDateFormat:'HH:mm' }} - {{ blocked.ends_at | amLocal | amDateFormat:'HH:mm' }}<br></span>
                    </ng-container>
                  </td> -->
                  <td>
                    <ng-container *ngFor="let availability of user.availabilities">
                      <span class="nowrap">{{ availability.start | timezone:'Europe/Berlin' | amDateFormat:'HH:mm' }}&nbsp;-&nbsp;{{ availability.end | timezone:'Europe/Berlin' | amDateFormat:'HH:mm' }}<br></span>
                    </ng-container>
                  </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="no-data" colspan="6">{{ t('common.labels.no_data') }}</td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>

    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="no-data" colspan="6">{{ t('common.labels.no_data') }}</td>
      </tr>
    </ng-template>

  </p-table>
</ng-container>
